<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
-->

<template>
  <label
    class="ffj-signature-ack"
    :class="{'ffj-signature-ack--disabled': disabled}"
  >
    <input
      type="checkbox"
      class="ffj-signature-ack__input"
      :checked="modelValue"
      :disabled="disabled"
      :data-testid="`ffj-signature-ack`"
      @change="onChange"
    />
    <span class="ffj-signature-ack__text">
      <slot>{{ $t('forfait_jours.signature_ack_label') }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'SignatureAckCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(event) {
      this.$emit('update:modelValue', event.target.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.ffj-signature-ack {
  font-family: 'Nunito Sans', sans-serif;
  color: var(--oxd-interface-gray-darken-1-color, #64728c);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
  &--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  &__input {
    width: 1rem;
    height: 1rem;
    cursor: inherit;
  }
  &__text {
    font-size: 0.875rem;
    color: #1e293b;
  }
  @media (max-width: 800px) {
    align-items: flex-start;
    &__input {
      margin-top: 0.15rem;
      flex: none;
    }
    &__text {
      font-size: 0.8125rem;
      line-height: 1.4;
    }
  }
}
</style>
